export const manifest = {
  screens: {
    scr_hz6wz9: { name: "Full-Doc", route: "/", state: {"selectedTab":"fullDoc"}, position: {"x":160,"y":220} },
    scr_5c3fqd: { name: "FHA Streamline / VA IRRRL", route: "/", state: {"selectedTab":"streamline"}, position: {"x":1560,"y":220} },
    scr_p0vyiz: { name: "HELOC", route: "/", state: {"selectedTab":"heloc"}, position: {"x":160,"y":2200} },
  },
  sections: {
    sec_65whuq: { name: "Mortgage Application Flow", x: 0, y: 0, width: 2920, height: 1180 },
    sec_97p0d5: { name: "HELOC Application Flow", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_65whuq", children: [
      { kind: "screen", id: "scr_hz6wz9" },
      { kind: "screen", id: "scr_5c3fqd" },
    ] },
    { kind: "section", id: "sec_97p0d5", children: [
      { kind: "screen", id: "scr_p0vyiz" },
    ] },
  ],
}
